<template>
	<div class="slider-outer">
		<input type="hidden" :value="value" v-on="inputListeners">
		<div
			ref="slider"
			class="slider-inner"
			:class="[{disable: disable}]"
			:style="sliderPosition"
		/>
		<div
			ref="knob"
			class="knob"
			:class="[{disable: disable}]"
			:style="knobPosition"
			@mousedown="move"
			@mouseup="stop"
		/>
	</div>
</template>

<script>
export default {
	name: 'TSlider',
	props: {
		disable: Boolean,
		value: {
			type: Number,
			default: 0
		},
		minValue: {
			type: Number,
			default: 0
		},
		maxValue: {
			type: Number,
			default: 50
		},
		// Offset handles knob positioning if it incorrectly lines up due to style changes
		offset: {
			type: Number,
			default: 0
		},
		// Width of slider in pixels. Default from default .slider-outer class
		sliderWidth: {
			type: Number,
			default: 90
		}
	},
	data() {
		return {
			sliderValue:
				this.minValue < this.value
				&& this.value < this.maxValue
					? this.value
					: this.minValue
		};
	},
	computed: {
		inputListeners() {
			return {
				...this.$listeners,
				input: event => {
					this.$emit('input', event.target.value);
				},
			};
		},
		sliderPosition() {
			let width = this.sliderWidth * ( this.sliderValue / (this.maxValue- this.minValue) ) - this.minValue;
			return `width: ${width}px`;
		},
		knobPosition() {
			let width = this.sliderWidth * ( this.sliderValue / (this.maxValue - this.minValue) )- this.minValue;
			return `transform: translateX(${width}px)`;
		}
	},
	methods: {
		updateValue(e) {
			window.addEventListener('mouseup', this.stop);
			if (!e) return;
			let sliderRect = this.$el.getBoundingClientRect();
			let mousePosition = e.clientX;
			if (mousePosition > sliderRect.left && mousePosition <= sliderRect.left + this.sliderWidth) {
				this.sliderValue = Math.round((
					((mousePosition - sliderRect.left) * (this.maxValue - this.minValue)) / (this.sliderWidth)* 10
				) / 10 + this.minValue + this.offset);
			} else if (mousePosition <= sliderRect.left) {
				this.sliderValue = this.minValue;
			} else if (mousePosition > sliderRect.left + this.sliderWidth) {
				this.sliderValue = this.maxValue;
			}
			this.$emit('input', this.sliderValue);
		},
		move() {
			if (this.disable) return;
			window.addEventListener('mousemove', this.updateValue);
		},
		stop() {
			window.removeEventListener('mousemove', this.updateValue);
			window.removeEventListener('mouseup', this.stop);
			this.$emit('change');
		}
	}
};
</script>

<style lang="scss" scoped>
div.slider-outer {
	padding-left: 10px;
	width: 90px;
	height: 6px;
	border-radius: 4px;
	background-color: #e4e7eb;
	position: relative;
}

div.slider-inner {
	height: 6px;
	border-radius: 4px;
	background-color: #1070ca;
	position: absolute;
	top: 0;
	left: 0;
}

div.knob {
	width: 16px;
	height: 16px;
	border-radius: 50%;
	box-shadow: 0 0 0 1px rgba(67, 90, 111, 0.3), 0 1px 2px 0 rgba(67, 90, 111, 0.3);
	background-image: linear-gradient(to top, #f4f5f7, #ffffff), linear-gradient(to bottom, #ffffff, #ffffff);
	position: absolute;
	left: -5px;
	top: -6px;
	cursor: grab;
	user-select: none;
	&.disable {
		background-image: linear-gradient(to top, #f4f5f7, #edf0f2), linear-gradient(to bottom, #ffffff, #ffffff);
		cursor: default;
	}
}
</style>